<template>
  <div
      class="configurator-page-search-results-tool-preview"
      :id="point.articleNr"
      :class="[
          point.isMarathon ? 'configurator-page-search-results-tool-preview--marathon' : '',
          point.disabled ? 'configurator-page-search-results-tool-preview--disabled' : '',
          point.selected ? 'configurator-page-search-results-tool-preview--selected' : ''
          ]"
      v-on:click="togglePoint(point)"
      :style="{ order: index }">

    <div class="configurator-page-search-results-tool-preview__name">
      <span class="icon-Marathon" v-if="point.isMarathon"></span>{{ point.name }}
    </div>

    <div class="configurator-page-search-results-tool-preview__image">
      <img :src="point.imageThumbnail" :alt="point.imageAlt"/>
    </div>

    <div class="configurator-page-search-results-tool-preview__properties">
      <div>
        <span class="icon" :class="[activeConfiguratorDepthIcon, 'tool-property']"></span>
        <p>{{ point.range }}</p>
      </div>

      <div v-if="point.width">
        <span class="icon" :class="[activeConfiguratorSizeIcon, 'tool-property']"></span>
        <p>{{ point.width }}</p>
      </div>

      <div v-for="category in point.categories" v-bind:key="category.id">
        <span class="tool-property" :class="category.iconClass"></span>
        <p>{{ category.name }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {getActiveConfiguratorDepthIconClass, getActiveConfiguratorSizeIconClass} from '../helpers/configuratorHelper';

const props = defineProps({
  point: Object,
  index: Number
});

const activeConfiguratorDepthIcon = getActiveConfiguratorDepthIconClass();
const activeConfiguratorSizeIcon = getActiveConfiguratorSizeIconClass();

const emit = defineEmits([
  'togglePoint'
]);

function togglePoint(point) {
  emit('togglePoint', point);
}
</script>